var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui centered grid"},[_c('div',{staticClass:"five wide column"},[_c('TheGraph',{attrs:{"graphname":"inventory","query":_vm.query}})],1),_vm._v(" "),_c('div',{staticClass:"five wide column"}),_vm._v(" "),_c('div',{staticClass:"five wide column"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b005923e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheDashboardTab.vue
// module id = null
// module chunks = 